import { useSelector } from "react-redux";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { postDataWithDotNet } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { errorHandler } from "../../../../helpers/errorHandler";
import { formatMoney } from "../../../../helpers/formatter";
import { IWalletTopUp } from "../../../../components/Requests/components/WalletTopUpDataTable";
import { MixPanel } from "../../../../shared/MixPanel/MixPanel";

interface IProps {
  properties: { item: IWalletTopUp };
  onCloseModal: () => void;
}
const ApproveAdminWalletWithdrawalModal = ({
  properties,
  onCloseModal,
}: IProps) => {
  const {
    narration,
    reference,
    user_id,
    funder_id,
    wallet_id,
    amount,
    transaction_date,
    wallet_provider_name,
    currency_code,
    funder_name,
    proof_of_payment_upload_path,
  } = properties?.item;
  const loggedInUser = useSelector(
    (state: any) => state?.authReducer?.loggedInUser,
  );
  const { roles } = loggedInUser;

  useEffect(() => {
    MixPanel.track(`Page View: ApproveAdminWalletTopUp.tsx`, {
      page: "ApproveAdminWalletTopUp.tsx",
    });
  }, []);

  const [comment, setComment] = useState("");
  const [isFormValid, setIsFormValid] = useState(true);
  const [TopSuccess, setTopSuccess] = useState("");
  const [error, setError] = useState("");
  const [approving, setApproving] = useState(false);
  const [rejecting, setRejecting] = useState(false);

  const submitHandleApprove = async () => {
    if (!comment) {
      return setIsFormValid(false);
    }
    try {
      setApproving(true);
      const response = await postDataWithDotNet(
        ajaxEndpoints.ADMIN_WALLET_TOP_UP_APPROVE,
        {
          comment,
          reference: reference,
        },
      );
      setTopSuccess(response?.message || "Success");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      setError(errorHandler(error));
    } finally {
      setApproving(false);
    }
  };

  const submitHandleReject = async () => {
    if (!comment) {
      return setIsFormValid(false);
    }
    try {
      setRejecting(true);
      const response = await postDataWithDotNet(
        ajaxEndpoints.ADMIN_WALLET_TOP_UP_REJECT,
        {
          comment,
          reference: reference,
        },
      );
      setTopSuccess(response?.message || "Success");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      setError(errorHandler(error));
    } finally {
      setRejecting(false);
    }
  };

  return (
    <div
      className="AuditTrailModal Modal__content"
      style={{ overflow: "hidden" }}
    >
      <div className="Modal__body">
        <Fragment>
          {TopSuccess && <p className="alert alert-success">{TopSuccess}</p>}
          <h3 className="Modal__title p-b-1">Wallet Top Up Request</h3>
          <hr />
          <div className="row">
            {/* TopUp Amount */}
            <div className="col-md-6 mb-3">
              <label>TopUp Amount:</label>
              <input
                type="text"
                className="form-control"
                value={formatMoney(amount || 0, currency_code)}
                readOnly
              />
            </div>
            {/* Funder Investment ID */}
            <div className="col-md-6 mb-3">
              <label>Wallet ID:</label>
              <input
                type="text"
                className="form-control"
                value={wallet_id}
                readOnly
              />
            </div>
            {/* Transaction Date */}
            <div className="col-md-6 mb-3">
              <label>Transaction Date:</label>
              <input
                type="text"
                className="form-control"
                value={moment(transaction_date).format("LL")}
                readOnly
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Funder Name:</label>
              <input
                type="text"
                className="form-control"
                value={funder_name}
                readOnly
              />
            </div>

            {/* Narration */}
            <div className="col-md-6 mb-3">
              <label>Narration:</label>
              <input
                type="text"
                className="form-control"
                value={String(narration) || ""}
                readOnly
              />
            </div>
            {/* Reference */}
            <div className="col-md-6 mb-3">
              <label>Reference:</label>
              <input
                type="text"
                className="form-control"
                value={reference}
                readOnly
              />
            </div>
            {/* User ID */}
            <div className="col-md-6 mb-3">
              <label>User ID:</label>
              <input
                type="text"
                className="form-control"
                value={user_id}
                readOnly
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Wallet Provider:</label>
              <input
                type="text"
                className="form-control"
                value={wallet_provider_name}
                readOnly
              />
            </div>
            {/* Funder ID */}
            <div className="col-md-6 mb-3">
              <label>Funder ID:</label>
              <input
                type="text"
                className="form-control"
                value={funder_id}
                readOnly
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Comment</label>
              <input
                type="text"
                className="form-control"
                name="comment"
                defaultValue={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                  setIsFormValid(true);
                }}
              ></input>
              {!isFormValid && <p className="text-danger">Enter a comment</p>}
            </div>
          </div>
          {/*      {roles &&
                        roles?.length > 0 &&
                        roles?.includes(ROLE_TYPES.INVESTMENT_WITHDRAWAL_APPROVER) && (*/}
          <>
            <hr />
            {error && (
              <p className="alert alert-danger col-md-6 offset-md-3">{error}</p>
            )}
            <div className="col-12 d-flex justify-content-end flex-wrap">
              <button
                className="btn advancly-btn btn-sm transition-3d-hover mt-2"
                type="button"
                disabled={!comment || !reference || approving || rejecting}
                onClick={submitHandleApprove}
              >
                {approving ? (
                  <span className="spinner-border spinner-border-sm text-white" />
                ) : (
                  "Approve"
                )}
              </button>
              <button
                className="btn btn-danger btn-sm transition-3d-hover mt-2"
                type="button"
                disabled={!comment || !reference || rejecting || approving}
                onClick={submitHandleReject}
              >
                {rejecting ? (
                  <span className="spinner-border spinner-border-sm text-white" />
                ) : (
                  "Reject"
                )}
              </button>
            </div>
          </>
          {/* )}*/}
        </Fragment>
      </div>
    </div>
  );
};

export default ApproveAdminWalletWithdrawalModal;
